var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Avance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 34.484375 12.984375 A 1.50015 1.50015 0 0 0 33.439453 15.560547 L 40.878906 23 L 18.5 23 A 1.50015 1.50015 0 1 0 18.5 26 L 40.878906 26 L 33.439453 33.439453 A 1.50015 1.50015 0 1 0 35.560547 35.560547 L 45.560547 25.560547 A 1.50015 1.50015 0 0 0 45.560547 23.439453 L 35.560547 13.439453 A 1.50015 1.50015 0 0 0 34.484375 12.984375 z M 3.5 23 A 1.5 1.5 0 0 0 3.5 26 A 1.5 1.5 0 0 0 3.5 23 z M 8.5 23 A 1.5 1.5 0 0 0 8.5 26 A 1.5 1.5 0 0 0 8.5 23 z M 13.5 23 A 1.5 1.5 0 0 0 13.5 26 A 1.5 1.5 0 0 0 13.5 23 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Avance);
export default __webpack_public_path__ + "static/media/icons8-avance.12615c9d21cc7b1acf4117f7f3169260.svg";
export { ForwardRef as ReactComponent };